import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import StudentProtectedRoute from "./StudentProtectedRoute";
import StudentPortalLayout from "./StudentPortalLayout";
import StudentLogin from "./Login/StudentLogin";
import StudentDashboard from "./Dashboard/StudentDashboard";
import StudentAttendance from "./Attendance/StudentAttendance";
import StudentTimetable from "./Timetable/StudentTimetable";
import StudentSyllabus from "./Syllabus/StudentSyllabus";
import StudentHomework from "./Homework/StudentHomework";
import StudentLeave from "./Leave/StudentLeave";
import StudentCircular from "./Circular/StudentCircular";
import StudentFaq from "./FAQ/StudentFaq";
import StudentWordOfTheDay from "./WordOfTheDay/StudentWordOfTheDay";
import StudentEvents from "./Events/StudentEvents";
import StudentNotifications from "./Notifications/StudentNotifications";
import StudentProfile from "./Profile/StudentProfile";
import StudentCourses from "./Courses/StudentCourses";
import StudentCourseDetail from "./Courses/StudentCourseDetail";
import StudentResult from "./Result/StudentResult";
import StudentFees from "./Fees/StudentFees";
import StudentNewsroom from "./Newsroom/StudentNewsroom";
import StudentAppointments from "./Appointments/StudentAppointments";
import StudentAppointmentCreate from "./Appointments/StudentAppointmentCreate";

// This module's own nested <Routes>, kept separate from the staff app's
// src/Routing.js so that file only ever gains the one line that mounts this
// component at /student-portal/* — no existing staff route is touched.
const StudentPortalRoutes = () => (
  <Routes>
    <Route path="login" element={<StudentLogin />} />

    <Route element={<StudentProtectedRoute component={StudentPortalLayout} />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<StudentDashboard />} />
      <Route path="attendance" element={<StudentAttendance />} />
      <Route path="timetable" element={<StudentTimetable />} />
      <Route path="syllabus" element={<StudentSyllabus />} />
      <Route path="homework" element={<StudentHomework />} />
      <Route path="leaves" element={<StudentLeave />} />
      <Route path="circulars" element={<StudentCircular />} />
      <Route path="faq" element={<StudentFaq />} />
      <Route path="word-of-the-day" element={<StudentWordOfTheDay />} />
      <Route path="events" element={<StudentEvents />} />
      <Route path="notifications" element={<StudentNotifications />} />
      <Route path="profile" element={<StudentProfile />} />
      <Route path="courses" element={<StudentCourses />} />
      <Route path="courses/:id" element={<StudentCourseDetail />} />
      <Route path="result" element={<StudentResult />} />
      <Route path="fees" element={<StudentFees />} />
      <Route path="newsroom" element={<StudentNewsroom />} />
      <Route path="appointments" element={<StudentAppointments />} />
      <Route path="appointments/create" element={<StudentAppointmentCreate />} />
    </Route>
  </Routes>
);

export default StudentPortalRoutes;
